import { ComponentPropsWithoutRef, FC } from 'react';

interface IProps extends ComponentPropsWithoutRef<'input'> {
  className?: string;
  errorMessage?: string;
}

const Input: FC<IProps> = ({ className = '', errorMessage, ...props }) => {
  return (
    <>
      <input
        {...props}
        className={`min-w-260px border outline-none focus:outline-none focus:ring-0 p-13px text-base font-base placeholder:text-hl-grey disabled:bg-hl-beige ${
          errorMessage ? 'border-hl-primary focus:border-hl-primary' : 'border-hl-black focus:border-hl-black'
        } ${className}`}
      />
      {errorMessage ? <span className='text-sm text-hl-primary'>{errorMessage}</span> : <></>}
    </>
  );
};

export default Input;
